<nav #navbar class="navbar-default navbar-fixed-top" role="navigation" [class.navBarColor]="transp"
    [class.addTop]="ourApp" [ngClass]="{dark:!transparent}">
    <div class="container">
        <div class="navbar-header page-scroll">
            <button type="button" class="navbar-toggle" (click)="openModal(template)">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <div *ngIf="display" class="title" [class.title1]="title!='Carte' || (title=='Carte' && !title1)"
                [class.b-bottom]="b_bottom">
                <div *ngIf="title=='Carte' && title1" class="order">
                    <span (click)="changeMode()">{{title1}}</span>
                    <img class="cli" alt="cli" src="assets/images/click.gif" width="60%">
                </div>
                <span *ngIf="title=='Carte' && !title1">
                    La carte
                </span>
                <span *ngIf="title!='Carte'">{{title1}}</span>
            </div>
            <div class="title title1" *ngIf="isNapoli && displayLogo">
                <div class="navbar-brand logo">
                    <img alt="logo" src="assets/images/logo1.png" width="100%">
                </div>
            </div>
            <button *ngIf="displayFilter" type="button" class="navbar-toggle navbar-filter" (click)="openFilter()">
                <img src="assets/images/search.png" alt="search" class="filter pull-right">
            </button>
        </div>
    </div>
</nav>
<ng-template #template>
    <div class="modal-header navbar-default">
        <button type="button" class="navbar-toggle" (click)="modalRef.hide()">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
        </button>
        <h4 class="modal-title">Menu</h4>
    </div>
    <div class="modal-body">
        <ul class="nav navbar-right">
            <li [ngClass]="{active: router.isActive('/',false)}">
                <img class="icon" src="assets/images/icons-menu/accueil1.png" alt="accueil">
                <a class="page-scroll" (click)="modalRef.hide()" [routerLink]="'/'">Accueil</a>
            </li>
            <li [ngClass]="{active: router.isActive('/carte',false)}">
                <img class="icon" src="assets/images/icons-menu/command.png" alt="command">
                <a (click)="toDirection()" class="cursor-pointer page-scroll">La carte</a>
            </li>
            <li *ngIf="log" [ngClass]="{active: router.isActive('/contact',false)}">
                <img class="icon" src="assets/images/icons-menu/commands.png" alt="contact">
                <a (click)="modalRef.hide()" class="page-scroll" [routerLink]="'/commandes'">Mes commandes</a>
            </li>
            <li *ngIf="log" [ngClass]="{active: router.isActive('/contact',false)}">
                <img class="icon" src="assets/images/icons-menu/compte1.png" alt="contact">
                <a (click)="modalRef.hide()" class="page-scroll" [routerLink]="'/compte/profil'">Mon compte</a>
            </li>

            <li [ngClass]="{active: router.isActive('/restaurant',false)}">
                <img class="icon" src="assets/images/icons-menu/rest.png" alt="restaurant">
                <a (click)="modalRef.hide()" class="page-scroll" [routerLink]="'/restaurant'">Le restaurant</a>
            </li>
            <!-- <li [ngClass]="{active: router.isActive('/contact',false)}">
                <img class="icon" src="assets/images/icons-menu/contact1.png" alt="contact">
                <a (click)="modalRef.hide()" class="page-scroll" [routerLink]="'/contact'">Contact</a>
            </li> -->
            <li *ngIf="log" [ngClass]="{active: router.isActive('/contact',false)}">
                <img class="icon" src="assets/images/icons-menu/logout.png" alt="contact">
                <a (click)="logout()" class="page-scroll">Déconnexion</a>
            </li>
            <li *ngIf="!log">
                <img class="icon" src="assets/images/icons-menu/compte1.png" alt="compte">
                <a (click)="modalRef.hide()" routerLink="/compte/connexion" class="login page-scroll">S'identifier / S'inscrire</a>
            </li>
        </ul>
        <div class="footer">
            <div class="d-flex">
                <a (click)="modalRef.hide()" routerLink="/cgv" class="login page-scroll">CGV</a>
                <a (click)="modalRef.hide()" routerLink="/mentions-légales" class="login page-scroll">Mentions
                    légales</a>
            </div>
            <p>Copyright © {{date | date:'yyyy'}} <a href="http://www.helpyfood.com" target="_blank">Helpyfood</a>. <br>
                Tous droits
                réservés.</p>
        </div>
    </div>
</ng-template>
<ng-template #template1>
    <div class="modal-body text-center">
        <p>
            <i class="fa fa-exclamation-triangle fa-2 text-navy" aria-hidden="true"></i>
        </p>
        <p *ngIf="!logoutaction">Si vous continuez, votre panier sera automatiquement vidé. Continuer ?</p>
        <p *ngIf="logoutaction">Voulez-vous vraimement vous déconnecter ?</p>
        <button type="button" class="btn btn-default" (click)="confirm()">OUI</button>
        <button type="button" class="btn btn-template" (click)="decline()">NON</button>
    </div>
</ng-template>